/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetTeamsUserTeamInvitationsTeamidQueryResponse,
  GetTeamsUserTeamInvitationsTeamidPathParams,
  GetTeamsUserTeamInvitationsTeamid401,
  GetTeamsUserTeamInvitationsTeamid500,
} from "../types/GetTeamsUserTeamInvitationsTeamid.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTeamsUserTeamInvitationsTeamidQueryKey = (
  teamId: GetTeamsUserTeamInvitationsTeamidPathParams["teamId"] | undefined,
) =>
  [
    { url: "/teams/user/team-invitations/:teamId", params: { teamId: teamId } },
  ] as const;

export type GetTeamsUserTeamInvitationsTeamidQueryKey = ReturnType<
  typeof getTeamsUserTeamInvitationsTeamidQueryKey
>;

/**
 * @summary Получить приглашение пользователя для конкретной команды
 * {@link /teams/user/team-invitations/:teamId}
 */
export async function getTeamsUserTeamInvitationsTeamid(
  teamId: GetTeamsUserTeamInvitationsTeamidPathParams["teamId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetTeamsUserTeamInvitationsTeamidQueryResponse,
    ResponseErrorConfig<
      | GetTeamsUserTeamInvitationsTeamid401
      | GetTeamsUserTeamInvitationsTeamid500
    >,
    unknown
  >({
    method: "GET",
    url: `/teams/user/team-invitations/${teamId}`,
    ...requestConfig,
  });
  return res;
}

export function getTeamsUserTeamInvitationsTeamidQueryOptions(
  teamId: GetTeamsUserTeamInvitationsTeamidPathParams["teamId"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getTeamsUserTeamInvitationsTeamidQueryKey(teamId);
  return queryOptions<
    ResponseConfig<GetTeamsUserTeamInvitationsTeamidQueryResponse>,
    ResponseErrorConfig<
      | GetTeamsUserTeamInvitationsTeamid401
      | GetTeamsUserTeamInvitationsTeamid500
    >,
    ResponseConfig<GetTeamsUserTeamInvitationsTeamidQueryResponse>,
    typeof queryKey
  >({
    enabled: !!teamId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getTeamsUserTeamInvitationsTeamid(teamId!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @summary Получить приглашение пользователя для конкретной команды
 * {@link /teams/user/team-invitations/:teamId}
 */
export function useGetTeamsUserTeamInvitationsTeamid<
  TData = ResponseConfig<GetTeamsUserTeamInvitationsTeamidQueryResponse>,
  TQueryData = ResponseConfig<GetTeamsUserTeamInvitationsTeamidQueryResponse>,
  TQueryKey extends QueryKey = GetTeamsUserTeamInvitationsTeamidQueryKey,
>(
  teamId: GetTeamsUserTeamInvitationsTeamidPathParams["teamId"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTeamsUserTeamInvitationsTeamidQueryResponse>,
        ResponseErrorConfig<
          | GetTeamsUserTeamInvitationsTeamid401
          | GetTeamsUserTeamInvitationsTeamid500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getTeamsUserTeamInvitationsTeamidQueryKey(teamId);

  const query = useQuery(
    {
      ...getTeamsUserTeamInvitationsTeamidQueryOptions(teamId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetTeamsUserTeamInvitationsTeamid401
      | GetTeamsUserTeamInvitationsTeamid500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
